export default (state = {}, action) => {
  if (action.type === "SET_ERROR_MESSAGE") {
    return {
      ...state,
      errorMessage: action.payload && action.payload.errorMessage
    };
  }
  return state;
};
